import React from 'react';
import SettingsSidebar from './SettingsSidebar';

interface SettingsLayoutProps {
  children: React.ReactNode;
}

const SettingsLayout: React.FC<SettingsLayoutProps> = ({ children }) => {
  return (
    <div className="max-w-[1200px] mx-auto px-8">
      <div className="flex gap-12">
        {/* Left Column - Sidebar */}
        <aside className="w-[300px] flex-shrink-0">
          <SettingsSidebar />
        </aside>

        {/* Right Column - Main Content */}
        <main className="flex-1 min-w-0">
          {children}
        </main>
      </div>
    </div>
  );
};

export default SettingsLayout;